const thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');

export const parseThirdPartyProduct = (ari: string) => {
	const result = thirdPartyRegex.exec(ari);
	if (!result) {
		throw new Error(
			`Invalid third party ARI. Use ${isThirdPartyARI.name} to check before calling this function.`,
		);
	}
	const [_, resourceOwner] = result;
	return resourceOwner;
};

export const isThirdPartyARI = (ari: string) => thirdPartyRegex.test(ari);
